import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportTable from "../components/ReportTable";
import PageHeader from "../components/PageHeader";
import SkSelect from "../components/SkSelect";
import DateRangeFilter from "../components/DateRangeFilter";
import Pagination from "../components/Pagination";
import { Row } from "jspdf-autotable";
import Loader from "../components/Loader";
import { fetchLeaveList, } from "../redux/Approval/LeaveApprovalActions";
import { updateLeaveApproval } from "../redux/Approvals/ApprovalActions";
import { getManualEntryList, updateManualApproval } from "../redux/Approvals/ApprovalActions";
import { selectManualEntryData, selectManualMeta } from "../redux/Approvals/ApprovalSelector";
import { selectLeaveEntryData, selectLeaveEntryLoading, seletctLeaveRequestMeta } from "../redux/Approval/LeaveApprovalSelector";
import "../assets/css/leaveapproval.css";
import moment from "moment-timezone";
import { formatWithTimeZone } from "../utils/common";
import "bootstrap-icons/font/bootstrap-icons.css";
import Status from "./Status";
import { exportToPDF } from "../utils/pdfExport";
import DownloadProgressModal from "../components/DownloadProgressModal";

const columns = [


  {
    key: "userName",
    label: "Employee",
  },
  {
    key: "leaveEntryDate",
    label: "Leave Entry Date",
    filterType: "date",
  },
  {
    key: "fromDate",
    label: "From Date",
    filterType: "date",
  },
  {
    key: "toDate",
    label: "To Date",
    filterType: "date",
  },
  {
    key: "reason",
    label: "Reason",
  },
  {
    key: "approval",
    label: "Approval",
    filterType: "select",
    filterOptions: [
      { value: "Pending", label: "Pending" },
      { value: "All", label: "All" },
      { value: "Approved", label: "Approved" },
      { value: "Rejected", label: "Rejected" },
    ]
  },
  //   {
  //     key: "action",
  //     label: "Action",
  //   },
];

const manualColumns = [
  {
    key: "userName",
    label: "Employee",
  },
  {
    key: "attendanceDate",
    label: "Attendance Date",
    filterType: "date",
  },
  {
    key: "clockIn",
    label: "Clock In",
  },
  {
    key: "clockOut",
    label: "Clock Out",
  },
  {
    key: "reason",
    label: "Reason",
  },
  {
    key: "approval",
    label: "Approval",
    filterType: "select",
    filterOptions: [
      { value: "Pending", label: "Pending" },
      { value: "All", label: "All" },
      { value: "Approved", label: "Approved" },
      { value: "Rejected", label: "Rejected" },
    ]
  },
];


const REQUEST_OPTIONS = [
  { label: "Leave", value: "Leave", },
  { label: "Manual", value: "Manual", },
];


function LeaveApproval() {
  const dispatch = useDispatch();

  const leaveList = useSelector(selectLeaveEntryData);
  // const loading = useSelector(selectLeaveEntryLoading);
  const leaveMeta = useSelector(seletctLeaveRequestMeta);
  const manualList = useSelector(selectManualEntryData);
  const manualMeta = useSelector(selectManualMeta);
  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const [selectedManuals, setSelectedManuals] = useState([]);
  const [statusFilter, setStatusFilter] = useState("Pending");
  const [loading, setLoading] = useState(false);
  const [requestType, setRequestType] = useState("Leave");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalReason, setApprovalReason] = useState("");
  const [filters, setFilters] = useState({
    UserName: "",
    LeaveEntryDate: "",
    FromDate: "",
    ToDate: "",
    AttendanceDate: "",
    ClockIn: "",
    ClockOut: "",
    Reason: "",
    ApprovalStatus: "Pending",
  });
  const [finalExportData, setFinalExportData] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [tableFilters, setTableFilters] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);


  const handleHeaderFilterChange = useCallback((cf) => {

    const newFilters = {
      UserName: cf.userName?.value || "",
      LeaveEntryDate: cf.leaveEntryDate?.start || "",
      FromDate: cf.fromDate?.start || "",
      ToDate: cf.toDate?.start || "",
      AttendanceDate: cf.attendanceDate?.start || "",
      ClockIn: cf.clockIn?.value || "",
      ClockOut: cf.clockOut?.value || "",
      Reason: cf.reason?.value || "",
      ApprovalStatus: cf.approval?.value || "Pending",
    };

    setFilters(prev => {
      if (JSON.stringify(prev) === JSON.stringify(newFilters)) {
        return prev;
      }
      return newFilters;
    });

    setCurrentPage(1);

  }, []);
  const buildParams = useCallback(() => {

    const user = JSON.parse(localStorage.getItem("user"));

    let statusPayload = {};

    switch (filters.ApprovalStatus) {
      case "Approved":
        statusPayload = {
          Approval: 1,
        };
        break;

      case "Rejected":
        statusPayload = {
          Reject: 1,
        };
        break;

      case "All":
        statusPayload = {};
        break;

      default: // Pending
        statusPayload = {
          Pending: 1,
        };
    }
    const params = {

      PageNumber: currentPage,
      PageSize: pageSize,
      ...statusPayload,
    };
    if (requestType === "Leave") {

      if (filters.LeaveEntryDate)
        params.LeaveEntryDate = moment(filters.LeaveEntryDate).format("YYYY-MM-DD");

      if (filters.FromDate)
        params.LeaveFromDate = moment(filters.FromDate).format("YYYY-MM-DD");

      if (filters.ToDate)
        params.LeaveToDate = moment(filters.ToDate).format("YYYY-MM-DD");

    } else {
      if (filters.UserName)
        params.UserName = filters.UserName;

      if (filters.AttendanceDate)
        params.AttendanceDate = moment(filters.AttendanceDate).format("YYYY-MM-DD");

      if (filters.ClockIn)
        params.ClockIn = filters.ClockIn;

      if (filters.ClockOut)
        params.ClockOut = filters.ClockOut;

    }
    if (filters.Reason)
      params.Reason = filters.Reason;
    return params;

  }, [currentPage, pageSize, filters]);
  useEffect(() => {

    const loadData = async () => {

      setLoading(true);

      try {

        if (requestType === "Leave") {

          await dispatch(
            fetchLeaveList(buildParams())
          );

        } else {

          await dispatch(
            getManualEntryList(buildParams())
          );

        }

      } finally {

        setLoading(false);

      }

    };

    const timer = setTimeout(loadData, 350);

    return () => clearTimeout(timer);

  }, [
    dispatch,
    requestType,
    buildParams,
    currentPage,
    pageSize,
  ]);
  const handleApprove = async () => {

    if (requestType === "Leave") {

      for (const id of selectedLeaves) {
        await dispatch(
          updateLeaveApproval({
            id,
            payload: {
              Approval: 1,
            },
          })
        );
      }

      dispatch(fetchLeaveList(buildParams()));
      setSelectedLeaves([]);

    } else {

      for (const id of selectedManuals) {
        await dispatch(
          updateManualApproval({
            id,
            payload: {
              Action: "APPROVE",
              // Reason: "",
              Reason: approvalReason,
            },
          })
        );
      }

      const user = JSON.parse(localStorage.getItem("user"));



      dispatch(getManualEntryList(buildParams()));

      setSelectedManuals([]);
    }
  };
  const handleReject = async () => {

    if (requestType === "Leave") {

      for (const id of selectedLeaves) {
        await dispatch(
          updateLeaveApproval({
            id,
            payload: {
              Reject: 1,
            },
          })
        );
      }

      dispatch(fetchLeaveList(buildParams()));

      setSelectedLeaves([]);

    } else {

      for (const id of selectedManuals) {
        await dispatch(
          updateManualApproval({
            id,
            payload: {
              Action: "REJECT",
              // Reason: "",
              Reason: approvalReason,
            },
          })
        );
      }

      const user = JSON.parse(localStorage.getItem("user"));

      dispatch(getManualEntryList(buildParams()));
      setSelectedManuals([]);
    }
  };

  const handleApprovalSubmit = async () => {

    if (!approvalReason.trim()) {
      alert("Reason is required");
      return;
    }

    if (approvalAction === "Approve") {
      await handleApprove();
    } else {
      await handleReject();
    }

    setShowApprovalModal(false);
    setApprovalReason("");
  };
  const filterLeaves = leaveList?.filter((item) => {
    if (statusFilter === "Pending") {
      return !item.Approval && !item.Reject;
    }

    if (statusFilter === "Approved") {
      return item.Approval;
    }

    if (statusFilter === "Rejected") {
      return item.Reject;
    }

    return true;
  })
  const data =
    leaveList?.map((item) => ({
      id: item.LeaveEntryCode,

      userName: (
        <div className="d-flex align-items-center gap-2">
          {filters.ApprovalStatus === "Pending" && (
            <input type="checkbox"
              checked={selectedLeaves.includes(item.LeaveEntryCode)}
              disabled={item.Approval || item.Reject}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedLeaves((prev) => [
                    ...prev,
                    item.LeaveEntryCode,
                  ]);
                } else {
                  setSelectedLeaves((prev) =>
                    prev.filter(
                      (id) => id !== item.LeaveEntryCode
                    )
                  )
                }
              }} />
          )}

          <span>{item.UserName}</span>
        </div>
      ),
      leaveEntryDate: formatWithTimeZone(
        item.LeaveEntryDate,
        "DD-MM-YYYY"
      ),

      fromDate: formatWithTimeZone(
        item.FromDate,
        "DD-MM-YYYY"
      ),

      toDate: formatWithTimeZone(
        item.ToDate,
        "DD-MM-YYYY"
      ),

      reason: item.Reason,

      approval: (
        <button
          className={
            item.Approval
              ? "status-btn approve-status"
              : item.Reject
                ? "status-btn reject-status"
                : "status-btn pending-status"
          }
        >
          {item.Approval
            ? "Approved"
            : item.Reject
              ? "Rejected"
              : "Pending"}
        </button>
      ),
    })) || [];
  const filterManuals = manualList?.filter((item) => {
    if (statusFilter === "Pending") {
      return !item.Approval && !item.Reject;
    }

    if (statusFilter === "Approved") {
      return item.Approval;
    }

    if (statusFilter === "Rejected") {
      return item.Reject;
    }

    return true;
  });

  const manualData =
    manualList?.map((item) => ({
      id: item.ManualCode,

      userName: (
        <div className="d-flex align-items-center gap-2">
          {filters.ApprovalStatus === "Pending" && (
            <input
              type="checkbox"
              checked={selectedManuals.includes(item.ManualCode)}
              disabled={item.Approval || item.Reject}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedManuals((prev) => [...prev, item.ManualCode]);
                } else {
                  setSelectedManuals((prev) =>
                    prev.filter((id) => id !== item.ManualCode)
                  );
                }
              }}
            />
          )}

          <span>{item.UserName}</span>
        </div>
      ),

      attendanceDate: formatWithTimeZone(
        item.AttendanceDate,
        "DD-MM-YYYY"
      ),

      clockIn: formatWithTimeZone(
        item.ClockIn,
        "hh:mm:ss A"
      ),

      clockOut: formatWithTimeZone(
        item.ClockOut,
        "hh:mm:ss A"
      ),

      reason: item.Reason,

      approval: (
        <button
          className={
            item.Approval
              ? "status-btn approve-status"
              : item.Reject
                ? "status-btn reject-status"
                : "status-btn pending-status"
          }
        >
          {item.Approval
            ? "Approved"
            : item.Reject
              ? "Rejected"
              : "Pending"}
        </button>
      ),
    })) || [];
  const handleExportClick = async () => {
    const exportRows =
      requestType === "Leave"
        ? filterLeaves.map((item) => ({
          userName: item.UserName,
          leaveEntryDate: formatWithTimeZone(item.LeaveEntryDate, "DD-MM-YYYY"),
          fromDate: formatWithTimeZone(item.FromDate, "DD-MM-YYYY"),
          toDate: formatWithTimeZone(item.ToDate, "DD-MM-YYYY"),
          reason: item.Reason,
          approval: item.Approval
            ? "Approved"
            : item.Reject
              ? "Rejected"
              : "Pending",
        }))
        : filterManuals.map((item) => ({
          userName: item.UserCode,
          leaveEntryDate: formatWithTimeZone(item.AttendanceDate, "DD-MM-YYYY"),
          fromDate: formatWithTimeZone(item.ClockIn, "hh:mm:ss A"),
          toDate: formatWithTimeZone(item.ClockOut, "hh:mm:ss A"),
          reason: item.Reason,
          approval: item.Approval
            ? "Approved"
            : item.Reject
              ? "Rejected"
              : "Pending",
        }));

    if (exportRows.length === 0) {
      alert("No data available to export.");
      return;
    }

    setIsDownloading(true)
    setDownloadProgress(0);

    await new Promise((resolve) => setTimeout(resolve, 100));

    for (let i = 10; i <= 90; i += 10) {
      setDownloadProgress(i);
      await new Promise((resolve) => setTimeout(resolve, 120));
    }

    exportToPDF(
      exportRows,
      requestType === "Leave" ? columns : manualColumns,
      `${requestType} Approval Report`
    );

    setDownloadProgress(100);

    await new Promise((resolve) => setTimeout(resolve, 600));
    setIsDownloading(false);
    setDownloadProgress(0);
  };
  return (

    <>
      {loading && <Loader isLoading={true} />}
      <div className="approval-page">
        <PageHeader className="leave-approval-header"
          icon={<i className="bi bi-calendar-check"></i>}
          title="Approval"
          // subtitle="Approve or Reject Requests"
          actions={

             <div className="leave-approval-actions">
            <div className="d-flex align-items-center gap-2">
              {/* <DateRangeFilter /> */}
              <div className="request-select">
              <SkSelect
                value={requestType}
                options={REQUEST_OPTIONS}
                onChange={(value) => {
                  setRequestType(value);
                  setCurrentPage(1);
                  setSelectedLeaves([]);
                  setSelectedManuals([]);
                }}
              />
              </div>
              {/* <SkSelect
                value={statusFilter}
                onChange={setStatusFilter}
                ariaLabel="Filter by approval status"
                width={150}
                options={STATUS_OPTIONS}
              /> */}
              <button className="btn btn-success approve-btn"
                disabled={
                  requestType === "Leave"
                    ? selectedLeaves.length === 0
                    : selectedManuals.length === 0
                }
                // onClick={handleApprove}
                onClick={() => {
                  setApprovalAction("Approve");
                  setApprovalReason("");
                  setShowApprovalModal(true);
                }}
              >
                Approve
              </button>

              <button className="btn btn-danger reject-btn"
                disabled={
                  requestType === "Leave"
                    ? selectedLeaves.length === 0
                    : selectedManuals.length === 0
                }
                // onClick={handleReject}
                onClick={() => {
                  setApprovalAction("Reject");
                  setApprovalReason("");
                  setShowApprovalModal(true);
                }}
              >
                Reject
              </button>
              <button
                className="btn btn-primary download-btn"
                style={{background: "#4a4ee8"}}
                onClick={handleExportClick}
              >
                <i className="bi bi-box-arrow-up"></i> 
              </button>
            </div>
            </div>
          }
        />

        <div className="table-container">

          {/* <ReportTable

            columns={requestType === "Leave" ? columns : manualColumns}
            data={requestType === "Leave" ? data : manualData}
            serverSide={true}
            onHeaderFilterChange={handleHeaderFilterChange}
          /> */}
          <ReportTable
            key={requestType}
            columns={requestType === "Leave" ? columns : manualColumns}
            data={requestType === "Leave" ? data : manualData}
            serverSide={true}
            onHeaderFilterChange={handleHeaderFilterChange}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalCount={requestType === "Leave"
            ? leaveMeta?.totalRecords || 0
            : manualMeta?.totalRecords || 0
          }
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={(size) => {
            setPageSize(size);
            setCurrentPage(1);
          }}
        />
        <DownloadProgressModal
          isOpen={isDownloading}
          progress={downloadProgress}
          fileName="Approval Report.pdf"
          onClose={() => setIsDownloading(false)} />
        {showApprovalModal && (
          <div className="se-overlay">
            <div className="se-modal">

              <div className="se-modal__header">
                <div>
                  <h3>{approvalAction} Request</h3>
                  <p className="se-modal__subtitle">
                    Enter reason for this action
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => setShowApprovalModal(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <div className="se-modal__body">

                <div className="se-field">

                  <label>Reason</label>

                  <textarea
                    rows={5}
                    className="se-input-reason"
                    value={approvalReason}
                    onChange={(e) =>
                      setApprovalReason(e.target.value)
                    }
                  />

                </div>

              </div>

              <div className="se-modal__footer">

                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => setShowApprovalModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleApprovalSubmit}
                >
                  {approvalAction}
                </button>

              </div>

            </div>
          </div>
        )}
      </div>
    </>


  );
}
export default LeaveApproval;